import { useEffect } from "react";

// Balises SEO propres à une page (titre, description, canonical, noindex).
// public/index.html est servi pour toutes les routes : il ne peut porter que des
// valeurs communes. Chaque page complète ici ses propres balises après le rendu,
// et Google les lit puisqu'il exécute le JavaScript.

const SITE_URL = "https://customer.cliclaim.com";

// Valeurs de public/index.html, restaurées en quittant la page.
const defaultTitle = document.title;
const defaultDescription =
  document.querySelector('meta[name="description"]')?.getAttribute("content") ||
  "";

const upsertHead = (selector, tag, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
};

const removeHead = (selector) =>
  document.head.querySelector(selector)?.remove();

/**
 * @param {object} meta
 * @param {string} [meta.title]       titre de l'onglet et de Google
 * @param {string} [meta.description] texte affiché sous le titre dans Google
 * @param {string} [meta.path]        chemin officiel de la page (ex. "/about") → canonical
 * @param {boolean} [meta.noindex]    exclure la page des résultats de recherche
 */
const usePageMeta = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    document.title = title || defaultTitle;
    upsertHead('meta[name="description"]', "meta", {
      name: "description",
      content: description || defaultDescription,
    });

    if (path) {
      upsertHead('link[rel="canonical"]', "link", {
        rel: "canonical",
        href: `${SITE_URL}${path}`,
      });
    }
    if (noindex) {
      upsertHead('meta[name="robots"]', "meta", {
        name: "robots",
        content: "noindex",
      });
    }

    return () => {
      document.title = defaultTitle;
      upsertHead('meta[name="description"]', "meta", {
        name: "description",
        content: defaultDescription,
      });
      if (path) removeHead('link[rel="canonical"]');
      if (noindex) removeHead('meta[name="robots"]');
    };
  }, [title, description, path, noindex]);
};

export default usePageMeta;
